/* globals $ theme */
import queryString from 'query-string'
import { history } from 'libs/history'

export const SEARCH_RESULTS = 'rcmSearchApi:searchResults'
export const ON_SEARCH = 'rcmSearchApi:onSearch'

const apiKey = (theme && theme.searchaniseApiKey) ? theme.searchaniseApiKey : ''

class RCMSearchAPI {
  constructor () {
    this.q = ''
    this.page = 1
    this.maxPages = 0

    this.filters = {
      tags: {
        queryString: '',
        items: [],
        urlKey: 'tags'
      },
      product_type: {
        queryString: '',
        items: [],
        urlKey: 'types'
      }
    }
    this.isFiltered = false
    this.sortBy = 'sales_amount'
    this.sortOrder = 'desc'
    this.returnFacets = ''
    this.collection = ''

    this._events = []
    this._requestCount = 0
  }

  init (options) {
    const parsedQuery = queryString.parse(window.location.search)
    const { returnFacets, collection, defaultSort } = options

    if (defaultSort) {
      const defaultSortPieces = defaultSort.split(':')
      if (defaultSortPieces.length) {
        this.sortBy = defaultSortPieces[0] ? defaultSortPieces[0] : this.defaultSortBy
        this.sortOrder = defaultSortPieces[1] ? defaultSortPieces[1] : this.defaultSortOrder
      }
    }

    for (let attribute in this.filters) {
      const filter = this.filters[attribute]
      if (parsedQuery[filter.urlKey]) {
        this.filters[attribute].queryString = parsedQuery[filter.urlKey]
        this.filters[attribute].items = this.parseFilterUrl(attribute, parsedQuery[filter.urlKey])
      }
    }
    if (parsedQuery.page) {
      this.page = parseInt(parsedQuery.page)
    }
    if (parsedQuery.sortBy) {
      this.sortBy = parsedQuery.sortBy
    }
    if (parsedQuery.sortOrder) {
      this.sortOrder = parsedQuery.sortOrder
    }
    if (parsedQuery.q) {
      this.q = parsedQuery.q
    }
    if (returnFacets) {
      this.returnFacets = 'true'
    }
    if (collection) {
      this.collection = collection
    }

    this.getResults(false)
  }

  getResults (updateUrl = true) {
    let data = {
      apiKey: apiKey,
      output: 'jsonp',
      returnFacets: 'false',
      maxResults: 16,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder
    }

    let urlQueryString = {}

    const {
      q,
      filters,
      page,
      collection,
      returnFacets,
      sortBy,
      sortOrder
    } = this

    if (q) {
      data['q'] = q
      urlQueryString.q = q
    }
    this.isFiltered = false
    for (let attribute in filters) {
      const filter = filters[attribute]
      if (filter.queryString) {
        data[`restrictBy[${attribute}]`] = filter.queryString
        urlQueryString[filter.urlKey] = filter.queryString
        this.isFiltered = true
      }
    }
    if (page) {
      data['startIndex'] = (parseInt(page) - 1) * data.maxResults
      urlQueryString.page = page
    }
    if (sortBy) {
      // custom sorting implemented by Searchanise for RCM allows us to sort by a specific metafield "general.sort_date"
      data['sortBy'] = (sortBy === 'sort_date') ? 'metafield_1bd2baf53e9d48e95e0b75d05bfefcde' : sortBy
      urlQueryString.sortBy = sortBy
    }
    if (sortOrder) {
      data['sortOrder'] = sortOrder
      urlQueryString.sortOrder = sortOrder
    }

    if (returnFacets) {
      data['facets'] = returnFacets
    }
    if (collection) {
      data['restrictBy[collection_handles]'] = collection
    }

    if (updateUrl) {
      history.push({
        pathname: window.location.pathname,
        search: queryString.stringify(urlQueryString)
      })
    }

    this._resolveEvents(ON_SEARCH, data)

    this._requestCount += 1
    let requestCount = this._requestCount
    $.ajax({
      type: 'GET',
      url: 'https://www.searchanise.com/getresults',
      dataType: 'jsonp',
      data: data,
      success: (response) => {
        if (requestCount < this._requestCount) {
          // this is a stale call
          return
        }
        const {
          totalItems,
          startIndex,
          itemsPerPage
        } = response

        this.maxPages = Math.ceil(totalItems / itemsPerPage)
        this.currentPage = parseInt((startIndex + itemsPerPage) / itemsPerPage) // *should* be an int, but just in case....
        this._requestCount += 1
        this._resolveEvents(SEARCH_RESULTS, response)
      }
    })
  }

  addFilter (attribute, value) {
    if (this.filters[attribute] && this.filters[attribute].items.indexOf(value) === -1) {
      this.filters[attribute].items.push(value)
      this.filters[attribute].queryString = this.createFilterUrl(attribute, this.filters[attribute].items)
      this.page = 1
      this.getResults()
    }
  }

  removeFilter (attribute, value) {
    if (!this.filters[attribute]) {
      return
    }
    const index = this.filters[attribute].items.indexOf(value)
    if (index > -1) {
      this.filters[attribute].items.splice(index, 1)
      this.filters[attribute].queryString = this.createFilterUrl(attribute, this.filters[attribute].items)
      this.page = 1
      this.getResults()
    }
  }

  setFilters (filters) {
    for (let attribute in filters) {
      if (this.filters[attribute]) {
        this.filters[attribute].items = filters[attribute]
        this.filters[attribute].queryString = this.createFilterUrl(attribute, this.filters[attribute].items)
      }
    }
    this.page = 1
    this.getResults()
  }

  setPage (page) {
    page = parseInt(page)
    if ((page > 0) && (page <= this.maxPages) && (page !== this.page)) {
      this.page = page
      this.getResults()
    }
  }

  nextPage () {
    if (this.page < this.maxPages) {
      this.page += 1
      this.getResults()
    }
  }

  prevPage () {
    if (this.page > 1) {
      this.page -= 1
      this.getResults()
    }
  }

  query (query) {
    query = query.trim()
    if (query) {
      this.q = query
      this.page = 1
      this.getResults()
    }
  }

  sort (sortBy, sortOrder) {
    if ((sortBy !== this.sortBy) || (sortOrder !== this.sortOrder)) {
      this.sortBy = sortBy
      this.sortOrder = sortOrder
      this.getResults()
    }
  }

  quickSearch (query, params) {
    let data = {
      apiKey: apiKey,
      output: 'jsonp',
      facets: 'true',
      q: query,
      suggestions: 'true',
      maxResults: 1,
      sortBy: 'relevance',
      sortOrder: 'asc'
    }

    if (typeof params !== 'undefined') {
      if (params.maxResults) {
        data.maxResults = params.maxResults
      }
      if (params.suggestions) {
        data.suggestions = params.suggestions
      }
      if (params.facets) {
        data.facets = params.facets
      }
      if (params.product_type) {
        data['restrictBy[product_type]'] = params.product_type
      }
      if (params.tags) {
        data['restrictBy[tags]'] = params.tags
      }
      if (params.sortBy) {
        data.sortBy = params.sortBy
      }
      if (params.sortOrder) {
        data.sortOrder = params.sortOrder
      }
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: 'https://www.searchanise.com/getresults',
        dataType: 'jsonp',
        data: data,
        success: (response) => {
          resolve(response)
        }
      })
    })
  }

  // ***********
  // Utility functions
  // ***********

  on (eventString, callback) {
    if (typeof callback !== 'function') {
      return
    }

    if (typeof this._events[eventString] === 'undefined') {
      this._events[eventString] = []
    }
    this._events[eventString].push(callback)
  }

  off (eventString, callback) {
    if (typeof this._events[eventString] === 'undefined') {
      return
    }

    let newArray = []
    for (let i = 0, len = this._events[eventString].length; i < len; i++) {
      if (callback !== this._events[eventString][i]) {
        newArray.push(this._events[eventString][i])
      }
    }
    this._events[eventString] = newArray
  }

  parseFilterUrl (attribute, urlString) {
    let items = []

    switch (attribute) {
      case 'tags':
        const groupArray = urlString.split(',')

        groupArray.forEach((filterGroup) => {
          const filters = filterGroup.split('|')
          items = items.concat(filters)
        })
        break

      case 'product_type':
        items = urlString.split(',')
        break
    }

    return items
  }

  createFilterUrl (attribute, items) {
    let itemString = ''

    switch (attribute) {
      case 'tags':
        let filters = []

        items.forEach((tag) => {
          const [ group ] = tag.split(':')
          if (typeof filters[group] === 'undefined') {
            filters[group] = []
          }
          filters[group].push(tag)
        })

        let filterGroups = []
        for (let group in filters) {
          filterGroups.push(filters[group].join('|'))
        }
        itemString = filterGroups.join(',')
        break

      case 'product_type':
        itemString = items.join('|')
        break
    }

    return itemString
  }

  // ***********
  // Internal functions
  // ***********

  _resolveEvents (eventString, data) {
    if (typeof this._events[eventString] === 'undefined') {
      return
    }

    for (let i = 0, len = this._events[eventString].length; i < len; i++) {
      this._events[eventString][i](data, this)
    }
  }
}

export const search = new RCMSearchAPI()
